module finadai.services {
  export class PaymentsService {
    paymentTypes: Array<models.PaymentType>;
    static instanceName = 'paymentsService';
    constructor(private proxifier, private $http: ng.IHttpService, private $q: ng.IQService, private $filter){
    }
    getAll(params?): ng.IHttpPromise<models.http.responses.Records<models.Payment>> {
      return this.$http.get([this.proxifier(), 'finadai', 'payments'].join('/'), { params: params });
    }
    downloadActivities(filters): ng.IHttpPromise<any>{
      return this.$http.post([this.proxifier(), 'finadai', 'payments', 'excel'].join('/'), {}, { params: filters });
    }
  }
}